import map from "lodash/map";
import { useEffect } from "react";
import ReactDOMServer from "react-dom/server";
import { useMap } from "react-map-gl/maplibre";
import { POLYGON_FILL_SVG, PREDEFINED_MARKERS } from "ui-components";
import rasterize from "~utils/functions/rasterize";

function svgStringToImageSrc(svgString) {
	return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgString);
}

export const MapImagePlugin = () => {
	const { current: currentMap } = useMap();

	useEffect(() => {
		if (!currentMap) return;

		currentMap.on("load", () => {
			map(PREDEFINED_MARKERS, ({ Icon, ...rest }, key) => {
				// Get the SVG string of the icon
				const iconString = ReactDOMServer.renderToString(
					<Icon
						weight="fill"
						{...rest}
					/>,
				);

				// Create an image from SVG
				const svgImage = new Image();
				svgImage.onload = () => {
					if (currentMap.hasImage(`${key}-icon`)) return;

					currentMap.addImage(`${key}-icon`, svgImage, {
						sdf: true,
					});
				};

				svgImage.src = svgStringToImageSrc(iconString);
			});
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (!currentMap) return;

		currentMap.on("styleimagemissing", (e) => {
			const id = e.id;

			if (!id.includes("-pattern-")) return;

			const patternName = id.split("-").shift();
			if (!patternName) return;

			const patternDef = POLYGON_FILL_SVG[patternName];
			if (!patternDef) return;

			const color = id.split("-").pop();
			if (!color) return;

			const { svg, width, height } = patternDef;
			const updatedSvg = svg.replace("#000000", color);
			const pngFromSvgpng = new Image();
			void rasterize(updatedSvg, width, height)
				.then((src) => {
					pngFromSvgpng.src = src;
					pngFromSvgpng.onload = () => {
						if (currentMap.hasImage(`${patternName}-pattern-${color}`)) return;

						currentMap.addImage(
							`${patternName}-pattern-${color}`,
							pngFromSvgpng,
						);
					};
				})
				.catch(console.error);
		});

		map(POLYGON_FILL_SVG, (patternDef, patternName) => {
			const { svg, width, height } = patternDef;
			const pngFromSvgpng = new Image();
			void rasterize(svg, width, height)
				.then((src) => {
					pngFromSvgpng.src = src;
					pngFromSvgpng.onload = () => {
						if (currentMap.hasImage(`${patternName}-pattern`)) return;

						currentMap.addImage(`${patternName}-pattern`, pngFromSvgpng);
					};
				})
				.catch(console.error);
		});
	}, [currentMap]);

	return null;
};
